import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-down',
  templateUrl: './down.component.html',
  styleUrls: ['./down.component.css']
})
export class DownComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
